import { useAsyncExecutor2 } from "async-executor-hook";
import { format } from "date-fns";
import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  from,
  interval,
  map,
  mapTo,
  startWith,
  Subject,
  switchMap,
  takeUntil,
} from "rxjs";

import { Authorization } from "../../common/AuthorizationCpt";
import {
  BodyContainerTableCommon,
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  DivStatusCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";
import { getErrorValueResponse } from "../../common/error/Error";
import { generateSequentialArray, removeNullUndefinedProps } from "../../common/utils";
import { HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import { SubtitleDiv } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";
import {
  ContainerConfigurate,
  ContainerScroll,
  DivDetailTitle,
} from "../AdminPaymentValidationSidebar/AdminPaymentValidationSidebarStyles";
import { AdminPaymentRecaudoStatesSidebar } from "../AdminPaymentValidationStatesSidebar/AdminPaymentRecaudoStatesSidebar";
import {
  InvoiceContainer,
  InvoicesContainer,
  TableHeaderCommon,
} from "../AdminPaymentValidationTable/CommonTable";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";
import {
  AmountInfo,
  FakeRow,
} from "../DocumentManagement/DocumentManagementSharedStyles";
import Sidebar from "../Sidebar/Sidebar";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import { ConvertResponseAdminPaymentRecaudo } from "./ConvertResponseAdminPaymentRecaudo";
import {
  AdminPaymentRecaudoParams,
  AdminPaymentRecaudoParams$,
  VolantesByInvoice,
} from "./AdminPaymentRecaudo.interface";

export const AdminPaymentRecaudoTable = (props: AdminPaymentRecaudoParams$) => {
  const { params$ } = props;
  const auxiliaryArray = generateSequentialArray(ITEMS_PER_PAGE);

  const [sidebarInfo, updateSidebarInfo] = useState<any>({
    agentName: "",
    salesInvoiceTotal: 0,
    invoiceNum: "",
    vouchers: [],
  });
  const handleClick = (newSidebarInfo) => {
    updateSidebarInfo(newSidebarInfo);
    updateShowStateSidebar(true);
  };
  const [messageError, updateMessageError] = useState("");
  const [showModalError, updateShowModalError] = useState(false);

  const toggleGetModal = () => {
    updateShowModalError(!showModalError);
  };

  const destroy$Ref = useRef(new Subject());
  const destroy$: any = destroy$Ref.current;
  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  const loadAdminRecaudo = useAsyncExecutor2(
    (params) => {
      const paramsNew = {
        bank_option: params.bank_type.length > 0 ? params.bank_type : [],
        payment_status_option:
          params.payment_status_option.length > 0
            ? params.payment_status_option
            : [],
        cashback_status_option:
          params.cashback_status_option.length > 0
            ? params.cashback_status_option
            : [],
        volante_nums: params.volante_nums.length > 0 ? params.volante_nums : [],
        agent_name: params.agent_name,
        from_date: params.from_date,
        to_date: params.to_date,
        order: params.order,
        page: params.page,
        page_size: params.page_size,
      };

      const destroy$ = destroy$Ref.current;
      return interval(10000).pipe(
        takeUntil(destroy$),
        startWith(paramsNew),
        mapTo(paramsNew),
        switchMap((params) => {
          const request = networkBackendRequest(
            "/invoices/upfront/payment-status/",
            HTTP_METHODS.GET,
            removeNullUndefinedProps(params),
            undefined
          )
            .then((response) => response.json())
            .then(ConvertResponseAdminPaymentRecaudo);
          return from(request);
        })
      );
    },
    {
      params$: params$.pipe(
        map((params: AdminPaymentRecaudoParams) => ({
          ...params,
          from_date: format(params.from_date, "yyyy-MM-dd"),
          to_date: format(params.to_date, "yyyy-MM-dd"),
          order: "descending",
          page: params.page ?? 1,
          page_size: ITEMS_PER_PAGE,
        }))
      ),
      onError: () => {},
    }
  );

  const respData = loadAdminRecaudo.data;
  const [showSidebarModal, setShowSidebarModal] = useState(false);
  const closeSideInfo = () => {
    setShowSidebarModal(!showSidebarModal);
  };

  const [showStateSidebar, updateShowStateSidebar] = useState(false);

  const gridTemplateColumnsSidebar = "1.2fr 1.5fr 1fr 1fr";
  const gridTemplateColumnsRecaudo = "1fr 1.5fr 2fr 1fr 1fr 1fr 1fr";
  const history = useHistory();

  const formatDate = (date: Date | string) => {
    const dateNew = format(new Date(date), "dd/MM/yyyy");
    return dateNew;
  };

  const formatDateSecond = (date: Date | string) => {
    const dateSecondnew = format(new Date(date), "HH:mm:ss");
    return dateSecondnew;
  };
  return (
    <div>
      {loadAdminRecaudo.isError && (
        <div>
          Algo salió mal
          <button
            type="button"
            onClick={() => {
              loadAdminRecaudo.retry();
            }}
          >
            Reintentar
          </button>
        </div>
      )}
      {showModalError && messageError && (
        <ConfirmationModal
          message={messageError}
          onAccept={() => {
            toggleGetModal();
          }}
          title={`Atención`}
          toggleModal={() => {
            toggleGetModal();
          }}
        />
      )}
      {loadAdminRecaudo.isLoading &&
        auxiliaryArray.map((_, index) => {
          return <FakeRow key={index} />;
        })}

      {loadAdminRecaudo.isSuccess && (
        <div>
          {respData.data.length === 0 && (
            <StandaloneMessage>
              No se encontraron pagos de recaudo con los parámetros brindados.
            </StandaloneMessage>
          )}

          {respData.data.length > 0 && (
            <Authorization
              actions={[
                "invoice.get_invoice_upfront",
                "invoice.patch_invoice_upfront",
              ]}
            >
              <div>
                <ContainerScrollCommon>
                  <ContainerConfigurateCommon>
                    <ContainerGridColumnsTableCommon
                      gridTemplateColumns={gridTemplateColumnsRecaudo}
                    >
                      <TableHeaderCommonResponsive className="item-container">
                        <div
                          className="main-info-header"
                          style={{ marginLeft: "2rem" }}
                        >
                          {"ID PAGO"}
                        </div>
                        <div>{"AGENTE DE ADUANA"}</div>
                        <div>{"FECHA/HORA DE SUBIDA"}</div>
                        <div>{"BANCO"}</div>
                        <div>{"MONTO"}</div>
                        <div>{"ESTADO DE PAGO"}</div>
                        <div>{"SUBESTADO"}</div>
                      </TableHeaderCommonResponsive>
                      <div
                        style={{ overflowY: "scroll", maxHeight: "90vh" }}
                        className="scroll"
                      >
                        {respData.data.map((elem) => {
                          return (
                            <div
                              key={elem.invoiceNum}
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClick(elem)}
                            >
                              <BodyContainerTableCommon
                                className="item-container"
                                height="8rem"
                              >
                                <div
                                  className="attribute"
                                  style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    height: "100%",
                                  }}
                                >
                                  <div className="titles">{"ID PAGO"}</div>
                                  <div>{elem.invoiceNum}</div>
                                </div>
                                <div
                                  className="attribute"
                                  style={{ height: "100%" }}
                                >
                                  <div className="titles">
                                    {"AGENTE DE ADUANA"}
                                  </div>
                                  <div className="left-align">
                                    {elem.agentName}
                                  </div>
                                </div>
                                <div
                                  className="attribute"
                                  style={{ height: "100%" }}
                                >
                                  <div className="titles">
                                    {"FECHA/HORA DE SUBIDA"}
                                  </div>
                                  <div>
                                    <b>{formatDate(elem.dateInvoice)}</b>
                                    <div>
                                      {formatDateSecond(elem.dateInvoice)}{" "}
                                    </div>
                                  </div>
                                </div>

                                <div className="attribute">
                                  <div className="titles">{"BANCO"}</div>
                                  <div>
                                    <div
                                      style={{
                                        fontWeight: 600,
                                        color: "#002E6C",
                                      }}
                                    >
                                      {elem.bankDetail.bank.name}
                                    </div>
                                    <div
                                      style={{
                                        fontWeight: 500,
                                        color: "#002E6C",
                                      }}
                                    >
                                      {elem.bankDetail.bank_payment_code}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="attribute"
                                  style={{ height: "100%" }}
                                >
                                  <div className="titles">{"MONTO"}</div>
                                  <AmountInfo>
                                    <div>{elem.currencyPayment}</div>
                                    <div>{`(${elem.dollarSol})`}</div>
                                  </AmountInfo>
                                </div>
                                <div
                                  className="attribute"
                                  style={{ height: "100%" }}
                                >
                                  <div className="titles">
                                    {"ESTADO DE PAGO"}
                                  </div>
                                  <DivStatusCommon
                                    status={elem.paymentStatus.category}
                                  >
                                    <div className="type-column-common">
                                      <b>
                                        {elem.paymentStatus.label.toUpperCase()}
                                      </b>
                                    </div>
                                  </DivStatusCommon>
                                </div>
                                <div
                                  className="attribute"
                                  style={{ height: "100%" }}
                                >
                                  <div className="titles">{"SUBESTADO"}</div>
                                  <DivStatusCommon
                                    status={elem.cashbackStatus.category}
                                  >
                                    <div className="type-column-common">
                                      <b>
                                        {elem.cashbackStatus.label.toUpperCase()}
                                      </b>
                                    </div>
                                  </DivStatusCommon>
                                </div>
                              </BodyContainerTableCommon>
                            </div>
                          );
                        })}
                      </div>
                    </ContainerGridColumnsTableCommon>
                  </ContainerConfigurateCommon>
                </ContainerScrollCommon>
                {loadAdminRecaudo.status === "SUCCESS" &&
                  loadAdminRecaudo.data.data.length > 0 && (
                    <div className="flex-paginator">
                      <Paginator
                        first={
                          (loadAdminRecaudo.data.page - 1) *
                          loadAdminRecaudo.data.page_size
                        }
                        rows={loadAdminRecaudo.data.page_size}
                        totalRecords={loadAdminRecaudo.data.count}
                        onPageChange={(e) => {
                          const targetPage =
                            e.first / loadAdminRecaudo.data.page_size;
                          const pathname = history.location.pathname;
                          const parsedParams = parse(history.location.search);
                          const stringifiedParams = stringify({
                            ...parsedParams,
                            page: targetPage + 1,
                          });
                          history.push(`${pathname}?${stringifiedParams}`);
                        }}
                      />
                    </div>
                  )}
              </div>
            </Authorization>
          )}
        </div>
      )}
      {showSidebarModal && (
        <Sidebar onOutsideClick={closeSideInfo}>
          <ContainerScroll>
            <ContainerConfigurate width="89.2rem" borderRadius="8px">
              <DivDetailTitle fontSize="2rem">Detalles del pago</DivDetailTitle>
              <InvoicesContainer
                gridTemplateColumns={gridTemplateColumnsSidebar}
              >
                <TableHeaderCommon className="item-container">
                  <div
                    className="main-info-header"
                    style={{ marginLeft: "2rem" }}
                  >
                    {"DAM"}
                  </div>
                  <div>{"RUC / RAZÓN SOCIAL FACTURABLE"}</div>
                  <div>{"HAWB / AWB"}</div>
                  <div>{"VOLANTE / PREFACTURA"}</div>
                </TableHeaderCommon>
                <div
                  style={{ overflowY: "scroll", maxHeight: "21.1vh" }}
                  className="scroll"
                >
                  {sidebarInfo &&
                    sidebarInfo.volantes.map((elem: VolantesByInvoice) => {
                      return (
                        <div key={elem.dam_num} style={{ cursor: "pointer" }}>
                          <InvoiceContainer
                            className="item-container"
                            height="7rem"
                          >
                            <div className="attribute main-info-header">
                              <div className="titles">{"DAM"}</div>
                              <div className="main-info-header">
                                <div className="left-align">{elem.dam_num}</div>
                              </div>
                            </div>
                            <div
                              className="attribute"
                              style={{ justifyContent: "start" }}
                            >
                              <div className="titles">{"RUC"}</div>
                              <SubtitleDiv color="#2E353D">
                                {elem.billable_ruc}
                              </SubtitleDiv>
                              <div className="titles">{"RAZÓN SOCIAL"}</div>
                              <SubtitleDiv color="#2E353D" fontWeight={500}>
                                {elem.billable_ruc_name}
                              </SubtitleDiv>
                            </div>
                            <div className="attribute">
                              <div className="titles">{"HAWB"}</div>
                              <SubtitleDiv color="#2E353D">
                                {elem.house_air_waybill}
                              </SubtitleDiv>
                              <div className="titles">{"AWB"}</div>
                              <SubtitleDiv color="#2E353D" fontWeight={500}>
                                {elem.master_air_waybill}
                              </SubtitleDiv>
                            </div>
                            <div className="attribute">
                              <div className="titles">{"VOLANTE"}</div>
                              <SubtitleDiv color="#2E353D">
                                {elem.volante_num}
                              </SubtitleDiv>
                              <div className="titles">{"PREFACTURA"}</div>
                              <SubtitleDiv color="#2E353D" fontWeight={500}>
                                {elem.factura_num}
                              </SubtitleDiv>
                            </div>
                          </InvoiceContainer>
                        </div>
                      );
                    })}
                </div>
              </InvoicesContainer>
            </ContainerConfigurate>
          </ContainerScroll>
        </Sidebar>
      )}

      {showStateSidebar && (
        <AdminPaymentRecaudoStatesSidebar
          respData={respData}
          sidebarInfo={sidebarInfo}
          onOutsideClick={() => updateShowStateSidebar(false)}
          setShowSidebarModal={setShowSidebarModal}
          onErrorEndpoint={(error) => {
            const errorMessage = getErrorValueResponse(error);
            updateMessageError(errorMessage);
            toggleGetModal();
          }}
          onOk={() => {
            updateShowStateSidebar(false);
            const parsedParams = {
              ...parse(window.location.search),
              page: 1,
            };
            const stringifiedParams = stringify(parsedParams);
            const pathname = history.location.pathname;
            history.push(`${pathname}?${stringifiedParams}`);
          }}
        />
      )}
    </div>
  );
};
